<template>
    <!--START FOOTER-->
        <footer class="footer">
            <div class="container">
                <div class="row">
                    <div class="col-lg-9 margin-t-20">
                        <h4>7 Settembru</h4>
                        <div class="text-muted margin-t-20">
                            <ul class="list-unstyled list-inline footer-list">
                                <li v-for="navItem in navBar"><a :href="'#' + navItem.link">{{ navItem.title}}</a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-lg-3 margin-t-20">
                        <h4>Subscribe</h4>
                        <div class="text-muted margin-t-20">
                            <p>To keep up with the latest news.</p>
                        </div>
                        <form class="form subscribe">
                            <input placeholder="Email" class="form-control" required>
                            <a data-toggle="modal" data-target="#subscriptionModal" class="submit"><i class="pe-7s-paper-plane"></i></a>
                        </form>
                    </div>
                </div>
            </div>
        </footer>
        <!--END FOOTER-->
</template>

<script>
    import navbar_data from "../../data/nav.json";

    export default {
      name: 'FooterSection',
      data() {
          return {
              navBar: navbar_data,
          }
      },
    }
</script>
